<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <template v-if="isBuka && isTerlaksana">
        <v-row>
          <v-col cols="12" lg="6">
            <div class="body-2">Tanggal Pelaksanaan</div>
            <div class="body-1 black--text">{{ $localDate(laporan.tgl_monev) || '-' }}</div>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="body-2">Moda Penyelenggaraan IHT</div>
            <div class="body-1 black--text">{{ $getDeepObj(laporan, 'm_monev_moda_psp.data.keterangan') || '-' }}</div>
          </v-col>
        </v-row>
        <div class="mt-5">
          <h2 class="black--text">Sasaran IHT</h2>
          <template v-for="(kelompok, key) in Object.keys(rekaps)">
            <div :key="key">
              <v-row :class="key === 0 ? 'mt-1' : 'mt-3'">
                <v-col cols="12" class="py-2">
                  <h3 class="black--text">
                    {{ $numberToAlpha(key) }}. {{ kelompok }}
                    <span class="grey--text font-weight-regular">(Jumlah Guru Mapel)</span>
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-for="(item, id) in rekaps[kelompok]" :key="`${kelompok}_${id}`" cols="12" lg="3">
                  <div class="body-2">{{ item.mapel }}</div>
                  <div class="body-1 black--text">{{ +item.jumlah > 0 ? `${item.jumlah} orang` : 'Tidak ada' }}</div>
                </v-col>
              </v-row>
            </div>
          </template>
        </div>
        <div class="mt-5">
          <foto-kegiatan :berkases="berkas.foto" />
        </div>
        <div class="mt-5">
          <foto-absensi :berkas="berkas.absensi" />
        </div>
      </template>
      <template v-else-if="isBuka && !isTerlaksana">
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="red" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>IHT Tidak Terlaksana</h2>
            <div class="body-2">
              {{ $getDeepObj(laporan, 'm_monev_alasan_psp.data.keterangan') }}
              <span v-if="+laporan.k_monev_alasan_psp === 99">({{ laporan.alasan_lain || '' }})</span>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>Laporan IHT Tidak Tersedia</h2>
            <div class="body-2 mt-1">
              Hal ini dikarenakan pihak terkait belum mengirimkan laporannya
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import FotoAbsensi from '../base/absensi';
import FotoKegiatan from '../base/foto';

export default {
  name: 'IhtBuka',
  components: { FotoAbsensi, FotoKegiatan },
  props: {
    laporan: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isBuka() {
      return this.laporan.k_verval_psp > 1;
    },

    isTerlaksana() {
      return +this.laporan.is_terlaksana === 1;
    },

    rekaps() {
      let result = {};

      for (const id in this.laporan.rekap_guru) {
        const rekap = this.laporan.rekap_guru[id] || {};
        const mapel = rekap.mapel || [];
        const kelompok = mapel[2] || `Jenjang ${this.$getDeepObj(this.laporan, 'sekolah.m_jenjang.singkat')}`;
        const namaMapel = mapel[0] || '';

        if (!result[kelompok]) {
          result[kelompok] = [
            {
              mapel: namaMapel,
              jumlah: rekap.jumlah || 0,
            },
          ];
        } else {
          result[kelompok].push({
            mapel: namaMapel,
            jumlah: rekap.jumlah || 0,
          });
        }
      }

      return result;
    },

    berkas() {
      const absensi = (this.$getDeepObj(this.laporan, 'psp_monev_berkases.data') || []).filter(
        (berkas) => +berkas.k_monev_berkas_psp === 4
      );
      const foto = (this.$getDeepObj(this.laporan, 'psp_monev_berkases.data') || []).filter((berkas) =>
        [1, 2, 3].includes(+berkas.k_monev_berkas_psp)
      );

      return {
        absensi: this.$getDeepObj(absensi[0], 'url_berkas'),
        foto: foto.map((file) => {
          return file.url_berkas;
        }),
      };
    },

    tautans() {
      return [
        {
          color: 'primary',
          content: [
            '<h2 class="black--text">Tautan Pre Test</h2>',
            '<p class="black--text mt-2">Berikut adalah tautan pre test sesuai UPT perwalian Anda</p>',
          ].join(''),
          contentButton: 'Pre Test',
          link: this.laporan.url_pretest || '',
        },
      ];
    },
  },
};
</script>

<style scoped></style>
